import styled from "styled-components";

/* Layout geral */
export const Container = styled.div`
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 120px 30px 80px 30px;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: #1e293b;
  }
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #2563eb;
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1d4ed8;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 20px;

  select, input {
    padding: 8px 12px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 14px;
    background-color: white;
  }
`;

export const TableWrapper = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;

    th, td {
      padding: 14px 16px;
      text-align: left;
      font-size: 14px;
    }

    thead {
      background-color: #f1f5f9;
      color: #475569;
    }

    tbody tr {
      border-top: 1px solid #e2e8f0;
    }

    .status {
      padding: 4px 10px;
      border-radius: 6px;
      font-size: 12px;
      text-transform: capitalize;
      font-weight: 600;
    }

    .pendente {
      background-color: #fef9c3;
      color: #92400e;
    }

    .pago {
      background-color: #dcfce7;
      color: #166534;
    }

    .vencido {
      background-color: #fee2e2;
      color: #991b1b;
    }

    .edit {
      color: #2563eb;
      background: none;
      border: none;
      cursor: pointer;
      margin-right: 8px;
    }

    .delete {
      color: #dc2626;
      background: none;
      border: none;
      cursor: pointer;
    }

    .empty {
      text-align: center;
      font-style: italic;
      color: #94a3b8;
      padding: 20px;
    }
  }
`;

/* Modal */
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 30px;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const Input = styled.input`
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  width: 100%;
`;

export const Select = styled.select`
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  width: 100%;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const ButtonCancelar = styled.button`
  background: #e5e7eb;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  cursor: pointer;

  &:hover {
    background: #d1d5db;
  }
`;

export const ButtonSalvar = styled.button`
  background: #2563eb;
  color: white;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  cursor: pointer;

  &:hover {
    background: #1d4ed8;
  }
`;
export const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
`;

export const Tab = styled.button`
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  font-weight: 500;
  background-color: ${(props) => (props.active ? "#2563eb" : "#e5e7eb")};
  color: ${(props) => (props.active ? "white" : "#1e293b")};
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => (props.active ? "#1d4ed8" : "#d1d5db")};
  }
`;

export const TabContent = styled.div`
  display: ${(props) => (props.visible ? "block" : "none")};
  margin-top: 20px;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
`;

export const FilterLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #334155;
`;

export const TextArea = styled.textarea`
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  width: 100%;
  min-height: 100px;
`;
